module.exports = {
    INITIAL_AMOUNT_OF_HISTORY_ROWS: 20
};
